import { CurrentSubscription } from "./CurrentSubscription.model";
export class DashboardData {
  constructor(data = {}) {
    this.verificationStatus = data?.verification_status;
    this.subscriptionPlanName = data?.subscription_plan_name;
    // Plan capability — drives the Analytics lock in the side menu / upsell page.
    this.accessToAnalytics = data?.access_to_analytics;
    // Stamped by the backend on the first branch activation. Onboarding never
    // re-gates after this, so the status request is skipped from then on. Only
    // truthiness is read; the timestamp itself is not displayed anywhere.
    this.onboardingCompletedAt = data?.onboarding_completed_at;
    this.currentSubscription = data?.current_subscription
      ? new CurrentSubscription(data.current_subscription)
      : undefined;
  }
}
